var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDydx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 24,
    viewBox: "0 0 77 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.4987 0.708679L58.801 23.0826H55.011L70.6268 0.708679H74.4987Z",
    stroke: "url(#paint0_linear_1008_93)",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.427 0.708679H59.3218L63.7777 7.10189L61.8695 9.96415L55.427 0.708679Z",
    stroke: "url(#paint1_linear_1008_93)",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9052 23.0826H71.1131L66.1388 15.9626L68.0377 13.1934L74.9052 23.0826Z",
    stroke: "url(#paint2_linear_1008_93)",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0915 23.0826H48.7089V22.7102V21.8686L47.9697 22.2711C46.7354 22.9433 45.3517 23.2941 43.9462 23.2913L43.944 23.2913C42.8457 23.2939 41.7577 23.0801 40.742 22.6622C39.7264 22.2443 38.8029 21.6304 38.0245 20.8557C37.2461 20.0809 36.6279 19.1604 36.2052 18.1467C35.7826 17.1333 35.5638 16.0467 35.561 14.9488C35.5635 13.8507 35.7822 12.7639 36.2046 11.7503C36.6272 10.7364 37.2454 9.81563 38.0238 9.04065C38.8023 8.26567 39.7258 7.65162 40.7416 7.2336C41.7574 6.81557 42.8456 6.60174 43.944 6.60433L43.946 6.60433C45.3517 6.6021 46.7353 6.9536 47.9695 7.62646L48.7089 8.02953V7.18746V0.708679H52.0915V23.0826ZM38.3656 14.8996L38.3656 14.9021C38.3692 16.366 38.9541 17.7686 39.9916 18.8013C41.0287 19.8337 42.4333 20.4122 43.8966 20.4095C44.6216 20.4127 45.34 20.2726 46.0108 19.9975C46.682 19.7221 47.2923 19.3169 47.8065 18.805C48.3207 18.2932 48.7287 17.6848 49.0071 17.0148C49.2856 16.3448 49.4289 15.6264 49.4289 14.9008L49.4289 14.8996C49.4252 13.4357 48.8403 12.0331 47.8028 11.0004C46.7655 9.96782 45.3608 9.38939 43.8972 9.39215C42.4337 9.38939 41.0289 9.96782 39.9916 11.0004C38.9541 12.0331 38.3692 13.4357 38.3656 14.8996Z",
    stroke: "url(#paint3_linear_1008_93)",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6298 0.708679L24.048 23.0826H20.1583L35.7582 0.708679H39.6298Z",
    stroke: "url(#paint4_linear_1008_93)",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9426 0.708679H24.057L28.8112 7.30638L26.615 10.3973L19.9426 0.708679Z",
    stroke: "url(#paint5_linear_1008_93)",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2394 23.0826H13.8568V22.7102V21.8686L13.1177 22.2711C11.8833 22.9433 10.4997 23.2941 9.09417 23.2913L9.09198 23.2913C7.9937 23.2939 6.90566 23.0801 5.88998 22.6622C4.87431 22.2443 3.95088 21.6304 3.17245 20.8557C2.39402 20.0809 1.77581 19.1604 1.35313 18.1467C0.930587 17.1333 0.711714 16.0467 0.708986 14.9488C0.711457 13.8507 0.93014 12.7639 1.35256 11.7503C1.77513 10.7364 2.39331 9.81564 3.17177 9.04065C3.95023 8.26566 4.87372 7.65162 5.88952 7.2336C6.90533 6.81557 7.99353 6.60174 9.09198 6.60433L9.09395 6.60433C10.4996 6.6021 11.8833 6.9536 13.1175 7.62646L13.8568 8.02953V7.18746V0.708679H17.2394V23.0826ZM3.5135 14.8996L3.5135 14.9021C3.51715 16.366 4.10203 17.7686 5.13955 18.8013C6.17667 19.8337 7.58122 20.4122 9.04454 20.4095C9.76951 20.4127 10.488 20.2726 11.1587 19.9975C11.83 19.7221 12.4402 19.3169 12.9544 18.805C13.4686 18.2932 13.8767 17.6848 14.1551 17.0148C14.4335 16.3448 14.5768 15.6264 14.5768 14.9008L14.5768 14.8996C14.5732 13.4357 13.9883 12.0331 12.9508 11.0004C11.9135 9.96782 10.5087 9.38939 9.04516 9.39215C7.58162 9.38939 6.17682 9.96782 5.13955 11.0004C4.10203 12.0331 3.51715 13.4357 3.5135 14.8996Z",
    stroke: "url(#paint6_linear_1008_93)",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1008_93",
    x1: 69.307,
    y1: 1.36338,
    x2: 55.0564,
    y2: 5.93952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9021FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1008_93",
    x1: 61.5335,
    y1: 0.73448,
    x2: 54.9557,
    y2: 2.88245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9021FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1008_93",
    x1: 72.892,
    y1: 12.8698,
    x2: 66.0164,
    y2: 15.0795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9021FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1008_93",
    x1: 47.5528,
    y1: 1.37369,
    x2: 35.4988,
    y2: 4.5153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9021FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1008_93",
    x1: 34.4401,
    y1: 1.36338,
    x2: 20.2008,
    y2: 5.93144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9021FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1008_93",
    x1: 26.4268,
    y1: 0.755099,
    x2: 19.52,
    y2: 3.03959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9021FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1008_93",
    x1: 12.7007,
    y1: 1.37369,
    x2: 0.646734,
    y2: 4.5153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9021FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDydx);
export default __webpack_public_path__ + "static/media/dydx.684e2db3b3944c413103cac2559a88dd.svg";
export { ForwardRef as ReactComponent };